<template>
	<b-container id="update-quantity" v-if="$can('view-quantity-update') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Quantity Update</h3>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-col class="text-center">
                <b-button size="xl" style="width: 200px; height: 50px; font-size: 20pt;" @click="openModal('QuantityUpdateUpload')">Import</b-button>
            </b-col>
        </b-row>

        <modal-upload
            v-if="modals.active"
        />

    </b-container>
</template>

<script>
    import QuantityUpdateUpload from './modals/QuantityUpdateUpload'
	export default {
        components: {
            'modal-upload': QuantityUpdateUpload
        },

		data() {
			return {
                name: 'QuantityUpdate',

                modals: {
                    active: 0
                }

			}
		},

		methods: {
            openModal(modalName) {
                this.modals.active = 1
                this.$nextTick(() => {
                    this.$bvModal.show(modalName)
                })
            },
		},

        mounted() {
            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                this.modals.active = 0
            })
        }
	}
</script>

<style lang="scss">
    #update-quantity {

    }
</style>
